import { VasStoreFacade } from "../../facades/vas-store-facade";
import { ConfigStoreFacade } from "./config.store-facade";
import { VasStore } from "../../store/store-type";
import { VasAppFacade } from "../../services/vas-app-facade.service";
import { StoreFacade } from "../../../core/store/facade/store-facade";

export class ConfigFacade extends VasStoreFacade {

    constructor(appFacade: VasAppFacade, storeService: VasStore, protected storeFacade: ConfigStoreFacade) {
        super(appFacade, storeService);

    }

    get store(): ConfigStoreFacade {
        return this.storeFacade;
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/config/config.facade.ts